import { gql } from '@apollo/client';

import { useMutationCompat as useMutation } from '../../lib/apollo/mutationCompat';

const IMPORT_BULK = gql`
  mutation ($csvContents: String!) {
    UploadBulkUserCsv(csvContents: $csvContents)
  }
`;

const ADD_USER = gql`
  mutation ($user: AddUserInput) {
    AddUserV2(user: $user)
  }
`;

const EDIT_USER = gql`
  mutation ($user: EditUserInput) {
    EditUserV2(user: $user)
  }
`;

const REMOVE_USER = gql`
  mutation ($user_id: String!) {
    RemoveUserV2(user_id: $user_id)
  }
`;

const SEARCH_MDM_ID = gql`
  mutation ($mdm_input: MdmInput!) {
    SearchMdmId(mdm_input: $mdm_input)
  }
`;

export function useUserMutations() {

  const [add] = useMutation(ADD_USER,
    { refetchQueries: ['getUsers'] },
  );

  const [edit] = useMutation(EDIT_USER,
    { refetchQueries: ['getUsers', 'contextGetUserByID'] },
  );

  const [remove] = useMutation(REMOVE_USER,
    { refetchQueries: ['getUsers'] },
  );

  const [uploadBulk] = useMutation(IMPORT_BULK,
    { refetchQueries: ['getUsers'] },
  );

  const [searchMdmId] = useMutation(SEARCH_MDM_ID);

  return { add, edit, remove, uploadBulk, searchMdmId };
}
